module.exports = __webpack_public_path__ + "static/paul-oakenfold-f8fe5f305cb3dca9f055f4b919588415.png";